/**
 * Created by Reda on 13.02.2025
 */

const FogLockView = cc.Node.extend({ 
    ctor: function (condition) {
        this._super();
        this.condition = condition;
        this.style = cleverapps.skins.getSlot("fogBlocker") || cleverapps.styles.FogLockView.default;
        this.setContentSize2(this.style);

        this.createLock();

        this.setCascadeColorEnabled(true);
        this.setCascadeOpacityEnabled(true);
    },

    createLock: function () {
        const lock = new cleverapps.Spine(bundles.fog.jsons.fog_blocker_json);
        lock.setAnimation(0, "idle", true);
        lock.setAlignment(this.style.lock);
        this.addChild(lock);
        this.lock = lock;

        if (this.style.lockAnimation) {
            const lockAnimation = this.style.lockAnimation;
            lock.runAction(new cc.RepeatForever(
                new cc.Sequence(
                    new cc.MoveBy(lockAnimation.duration, 0, -lockAnimation.delta).easing(cc.easeInOut(1.7)),
                    new cc.MoveBy(lockAnimation.duration, 0, lockAnimation.delta).easing(cc.easeInOut(1.7))
                )
            ));
        }

        const iconSlot = lock.hasSlot("slot_icon") && lock.getSlot("slot_icon");
        const levelSlot = lock.hasSlot("slot_level") && lock.getSlot("slot_level");

        const smallIcon = (unit) => (bundles[`unit_${unit.code}`] || UnitView.GetUnitBundle(unit)).frames[`${unit.code}_small_icon`];

        let frame = this.condition.hero && smallIcon({ code: this.condition.hero, stage: 0 });
        if (frame && frame.resolve()) {
            const heroIcon = new cc.Sprite(frame);
            if (iconSlot) {
                iconSlot.addChild(heroIcon);
            } else {
                heroIcon.setAlignment(this.style.icon);
                this.addChild(heroIcon);
            }
        }

        if (this.condition.level) {
            const levelText = cleverapps.UI.generateImageText(this.condition.level, cleverapps.styles.FONTS.FOG_BLOCKER_TEXT);
            if (levelSlot) {
                levelSlot.addChild(levelText);
            } else {
                levelText.setAlignment(this.style.text.x, this.style.text.y);
                levelText.fitTo(this.style.content.width, this.style.content.height);
                this.addChild(levelText);
            }
        }

        if (this.condition.familyLastUnit) {
            const unit = this.condition.familyLastUnit;
            frame = smallIcon(unit);
            let castle;
            if (frame && frame.resolve()) {
                castle = new cc.Sprite(frame);
            } else {
                castle = UnitView.getUnitImage(unit, {
                    preferStatic: true
                });
                cleverapps.UI.fitToBox(castle, this.style.content);
            }
            if (iconSlot) {
                iconSlot.addChild(castle);
            } else {
                castle.setAlignment(this.style.icon);
                this.addChild(castle);
            }
        }

        if (this.condition.unit) {
            frame = !this.condition.unit.stageIcon && smallIcon(this.condition.unit);
            let unit;
            if (frame && frame.resolve()) {
                unit = frame && new cc.Sprite(frame);
            } else {
                unit = UnitView.getUnitImage(this.condition.unit, {
                    preferStatic: true
                });
                cleverapps.UI.fitToBox(unit, this.style.content);
            }
            if (iconSlot) {
                iconSlot.addChild(unit);
            } else {
                unit.setAlignment(this.style.icon);
                this.addChild(unit);
            }
        }
    },

    checkCondition: function (condition) {
        const unitCompare = this.condition.unit && condition.unit
            ? this.condition.unit.code === condition.unit.code && this.condition.unit.stage === condition.unit.stage
            : this.condition.unit === condition.unit;
        const familyLastUnitCompare = this.condition.familyLastUnit && condition.familyLastUnit
            ? this.condition.familyLastUnit.code === condition.familyLastUnit.code && this.condition.familyLastUnit.stage === condition.familyLastUnit.stage
            : this.condition.familyLastUnit === condition.familyLastUnit;
        return unitCompare && familyLastUnitCompare
            && condition.level === this.condition.level;
    },

    openAnimation: function (newParent) {
        this.replaceParentSamePlace(newParent);
        this.runAction(new cc.Sequence(
            new cc.CallFunc(() => {
                this.lock.replaceParentSamePlace(newParent);
                this.lock.setLocalZOrder(-1);
                this.lock.setAnimation(0, "open", false);
                this.lock.setCompleteListenerRemove();
            }),
            new cc.Spawn(
                new cc.JumpBy(0.2, 30, 0, 20, 1),
                new cc.RotateBy(0.2, 80).easing(cc.easeIn(1))
            ),
            new cc.RemoveSelf()
        ));
    }
});

cleverapps.styles.FogLockView = {};

cleverapps.styles.FogLockView.default = {
    width: 100,
    height: 100,
    margin: 25,

    content: {
        width: 68,
        height: 68
    },
    text: {
        x: { align: "center", dx: 5 },
        y: { align: "center", dy: -28 }
    },
    icon: {
        x: { align: "center", dx: 5 },
        y: { align: "center", dy: -28 }
    },
    cloud: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: -39 }
    },
    lock: {
        x: { align: "center" },
        y: { align: "center" }
    },
    lockAnimation: {
        duration: 1.7,
        delta: 10
    }
};

cleverapps.styles.FogLockView.expedition = cleverapps.overrideStyles(cleverapps.styles.FogLockView.default, {
    position: {
        x: { align: "center" },
        y: { align: "center", dy: 50 }
    },
    lockAnimation: {
        duration: 1.7,
        delta: 10
    }
}, true);